import React, { useEffect, useRef } from "react";
import pdfMake from "pdfmake/build/pdfmake";
// import pdfFonts from "pdfmake/build/vfs_fonts";
import { Modal } from "antd";
import statementDataMapper from "@/views/accounts/statement-data-mapper";
import { useStatement,useLegerCard } from "@/hooks/accounts/useCustomerAccount";
import { vfs } from "./vfs";
import {AccountRequestDto} from "@/shared/api/model";

// Correctly set up pdfMake fonts
//@ts-ignore
// pdfMake.vfs = pdfFonts.pdfMake.vfs;
// @ts-ignore
 (pdfMake as any).vfs = vfs();


interface PdfMakeModalProps {
  title: string;
  show: boolean;
  statementRequest: AccountRequestDto;
  handleShow: (show: boolean) => void;
}

const PdfMakeModal: React.FC<PdfMakeModalProps> = ({
                                                     title,
                                                     show,
                                                     statementRequest,
                                                     handleShow,
                                                   }) => {
  const [statementQuery] = useStatement(statementRequest, show);
  const { isLoading, isError, data } = statementQuery;
  const iframeRef = useRef<HTMLIFrameElement>(null);


  useEffect(() => {
    const generatePDF = async () => {

      if (data) {
        const dd = statementDataMapper(data);
        // @ts-ignore
        const pdfDocGenerator = pdfMake.createPdf(dd);

        if (window.matchMedia("(max-width: 500px)").matches) {
          pdfDocGenerator.download();
        } else {
          const dataUrl = await new Promise<string>((resolve) => {
            pdfDocGenerator.getDataUrl((url) => resolve(url));
          });

          if (iframeRef.current) {
            iframeRef.current.src = dataUrl;
          }
        }
      }
    };

    if (show) {
      generatePDF();
    }
  }, [data, show]);

  return (
      <Modal
          title={title}
          centered
          open={show}
          onOk={() => handleShow(false)}
          onCancel={() => handleShow(false)}
          width="80vw"
          style={{ width: "100%", resize: "horizontal", height: "90vh" }}
      >
        <div className="flex h-full">
          {isLoading && <p>Loading...</p>}
          {isError && <p>Error loading statement</p>}
          {!isLoading && !isError && (
              <iframe
                  ref={iframeRef}
                  style={{ width: "100%", height: "70vh", border: "none" }}
                  title="PDF Statement"
              />
          )}
        </div>
      </Modal>
  );
};

export default PdfMakeModal;